<template>
  <cReport :reportName="reportName" :listReportData="lsReportData" :listReportTableData="lsReportTableData" :lsReportFields="getReportTableFields()" @submit="onGetCreditSalesReport"     :defaultFields="defaultColumns" :columnsToMerge="columnsToMerge" :reportDetails="GET_SELECTED_AGENT"
/>
</template>

<script>
import cReport from "../../components/report/cReport";
import {
  PATHNAME,
  COMPONENT_NAME,
  ALERT_MODAL_STATUS,
  ORDER,
  DATE_TIME_FORMAT
} from "../../../src/util/constants";
import apiGetCreditSaleReportSummary from "../../../src/services/apiGetCreditSaleReportSummary";
import { VALIDATE_SUCCESS_RES, getErrorMessage } from "@/util/apiValidate.js";
import {
  addClassToBody,
  removeClassBody,
  handleJWT,
  getErrorAlertValue,
  cloneDeep,
  cloneData,
  OrderByList
} from "../../../src/util/util";
import {
  LOG_TYPE,
  FILE_NAME,
  HTTP_CODES,
  API_VALUES
} from "../../config/API_DATA";
import Logger from "../../services/logger";
import BaseConfiguration from "../../config/base.js";
    import {mapGetters} from "vuex";

export default {
  name: COMPONENT_NAME.CREDIT_SALES_REPORT,
  components: {
  cReport
  },
  data: () => {
    return {
      reportName:COMPONENT_NAME.CREDIT_SALES_REPORT,
     lsReportData:null,
     lsReportTableData:null,
     defaultColumns:null,
     columnsToMerge:null
    };
  },

  methods: {
   
    

   async onGetCreditSalesReport(pReportQuery) {
        try {
          if(BaseConfiguration.isDebug) console.log("onGetCreditSalesReport");
         
     this.lsReportData = await this.getCreditSalesReport(
          pReportQuery.fromDate,
          pReportQuery.toDate,
          pReportQuery.lsCurrCode,
         this.GET_SELECTED_AGENT?this.GET_SELECTED_AGENT.id:null,
        
        );
        if (this.lsReportData && this.lsReportData.report) {
          this.lsReportTableData = this.lsReportData.report;
        }else{
          this.lsReportTableData=[];
        }
        } catch (err) {
                let body = Logger.buildRequest(
                 COMPONENT_NAME.CREDIT_SALES_REPORT,
                  "error in onGetCreditSalesReport",
                  err.toString(),
                  "onGetCreditSalesReport",
                  LOG_TYPE.ERROR
                );
                Logger.getResponse(body);
              }
         
        }, 
   
   
    async getCreditSalesReport(pFromDate, pToDate, pLsCurrCode, pSubId) {
      let retValue;
      try {
        if (BaseConfiguration.isDebug) console.log("getCreditSalesReport");

        let systemReportReq = apiGetCreditSaleReportSummary.buildRequest(
          pFromDate,
          pToDate,
          pLsCurrCode,
         pSubId
        );
        if (systemReportReq) {
          let systemReportRes = await apiGetCreditSaleReportSummary.getResponse(
            systemReportReq
          );

          if (systemReportRes) {
            if (VALIDATE_SUCCESS_RES(systemReportRes)) {
              retValue = systemReportRes.data.data;
            } else {
              //if status error
              retValue = null;
              let error = getErrorMessage(systemReportRes);

              let isJwt = handleJWT(error);
              if (!isJwt) {
                this.alertValue = getErrorAlertValue(error);
              }
            }
          }
        }
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.CREDIT_SALES_REPORT,
          "error in getCreditSalesReport",
          err.toString(),
          "getCreditSalesReport",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return retValue;
    },

    getReportTableFields() {
      let retValue = [];
      try {
        if (BaseConfiguration.isDebug) console.log("getReportTableFields");
        retValue = [
          {
            key: "ts",
            label: this.$t('cReport.transactionDate'),
            isLocked: true
          },
         {
            key: "orderId",
            label: this.$t('cReport.reservationId'),
            isLocked: true
          },
           {
            key: "pnr",
            label: this.$t('cReport.pnr'),
            isLocked: true
          },

          {
            key: "description",
            label: this.$t('cReport.description'),
            isLocked: false
          },
          {
            key: "reference",
            label: this.$t('cReport.reference'),
            isLocked: false
          },

          {
            key: "transactiontype",
            label: this.$t('cReport.transactionType'),
            isLocked: true
          },
          
          {
            key: "agentsales",
            label: this.$t('cReport.agentSales'),
            isLocked: true
          },
          {
            key: "agentpayment",
            label: this.$t('cReport.agentPaymentSettlement'),
            isLocked: true
          },
          {
            key: "after_amount",
            label:this.$t('cReport.creditBalance'),
            isLocked: true
          },
        
        ];
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.CREDIT_SALES_REPORT,
          "error in getReportTableFields",
          err.toString(),
          "getReportTableFields",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return retValue;
    },
    
    
    
  },
  computed: {
    ...mapGetters("sCreditSaleReport", {
      GET_SELECTED_AGENT: "GET_SELECTED_AGENT",
    }),
  },
  async created() {
    try {
      if (BaseConfiguration.isDebug) console.log("created");
    this.defaultColumns=[ {
            key: "ts",
            label: this.$t('cReport.transactionDate'),
            isLocked: true
          },
         {
            key: "reservasionid",
            label: this.$t('cReport.reservationId'),
            isLocked: true
          },
           {
            key: "pnr",
            label: this.$t('cReport.pnr'),
            isLocked: true
          },

          {
            key: "description",
            label: this.$t('cReport.description'),
            isLocked: false
          },
          {
            key: "reference",
            label: this.$t('cReport.reference'),
            isLocked: false
          },

          {
            key: "transactiontype",
            label: this.$t('cReport.transactionType'),
            isLocked: true
          },
          
          ,];
          this.columnsToMerge=[
            {
            key: "agentsales",
            label: this.$t('cReport.agentSales'),
            isLocked: true
          },
          {
            key: "agentpayment",
            label: this.$t('cReport.agentPaymentSettlement'),
            isLocked: true
          },
         
          {
            key: "after_amount",
            label: this.$t('cReport.creditBalance'),
            isLocked: true
          }
          ]
     
    } catch (err) {
      let body = Logger.buildRequest(
        COMPONENT_NAME.CREDIT_SALES_REPORT,
        "error in created",
        err.toString(),
        "created",
        LOG_TYPE.ERROR
      );
      Logger.getResponse(body);
    }
  }
};
</script>

<style>
</style>